import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { TopicTypes } from '../data/topicEditor/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ZeroState = ({
  onOpenCreateTopicDialog
}) => {
  return /*#__PURE__*/_jsxs("section", {
    "data-test-id": "topic-editor-zero-state",
    children: [/*#__PURE__*/_jsx(UIButton, {
      onClick: () => onOpenCreateTopicDialog(TopicTypes.CLUSTER),
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.zeroState.actions.addCoreTopic"
      })
    }), /*#__PURE__*/_jsx("p", {
      className: "m-top-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.zeroState.description"
      })
    })]
  });
};